import React from 'react';
import { Box } from '@mui/material';
import type { GalleryPhoto } from '../GalleryGrid';
import PhotoCard from '../PhotoCard';

export interface RhythmBlockProps {
   photos: GalleryPhoto[];
   startIndex: number;
   onPhotoClick: (index: number) => void;
   currentUser?: { uid: string } | null;
   albumId?: string;
}

const SLOT_STYLES: Array<{ gridColumn: string; gridRow: string }> = [
   { gridColumn: '1 / 3', gridRow: '1 / 2' },
   { gridColumn: '3 / 4', gridRow: '1 / 3' },
   { gridColumn: '4 / 6', gridRow: '1 / 2' },
   { gridColumn: '1 / 2', gridRow: '2 / 3' },
   { gridColumn: '2 / 3', gridRow: '2 / 3' },
   { gridColumn: '4 / 5', gridRow: '2 / 3' },
   { gridColumn: '5 / 6', gridRow: '2 / 3' },
   { gridColumn: '6 / 7', gridRow: '1 / 3' },
];

export default function RhythmBlock({ photos, startIndex, onPhotoClick, currentUser, albumId }: RhythmBlockProps) {
   return (
      <Box
         sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gridTemplateRows: 'repeat(2, 200px)',
            gap: 2,
            mb: 2,
            '@media (max-width: 640px)': {
               gridTemplateColumns: 'repeat(2, 1fr)',
               gridTemplateRows: 'auto',
               '& > *': { gridColumn: 'auto !important', gridRow: 'auto !important' },
            },
            '@media (min-width: 641px) and (max-width: 1024px)': {
               gridTemplateColumns: 'repeat(4, 1fr)',
               gridTemplateRows: 'auto',
               '& > *': { gridColumn: 'auto !important', gridRow: 'auto !important' },
            },
         }}
      >
         {photos.map((photo, i) => (
            <Box
               key={photo.id}
               sx={{
                  minHeight: 80,
                  ...(photos.length <= 8 && SLOT_STYLES[i]
                     ? {
                          gridColumn: SLOT_STYLES[i].gridColumn,
                          gridRow: SLOT_STYLES[i].gridRow,
                          '@media (max-width: 640px)': { gridColumn: 'auto', gridRow: 'auto' },
                          '@media (min-width: 641px) and (max-width: 1024px)': {
                             gridColumn: 'auto',
                             gridRow: 'auto',
                          },
                       }
                     : {}),
               }}
            >
               <PhotoCard
                  photo={photo}
                  aspectRatio='square'
                  onClick={() => onPhotoClick(startIndex + i)}
                  showLikeButton={!!currentUser}
                  userId={currentUser?.uid}
                  albumId={albumId}
                  likeCount={photo.likeCount ?? 0}
                  isLiked={photo.isLiked ?? false}
               />
            </Box>
         ))}
      </Box>
   );
}
